<div class="demo-scroll-container">
    <upp-scrollable [scrollbar]="'y'">
        <div class="demo-content">
            <h2>upp-thumb</h2>
            <p class="demo-description">Team member cards showcasing different <code>upp-thumb</code> configurations. Use the color buttons to override all thumbnails.</p>

            <div class="demo-section">
                <h3>Team Members</h3>
                <div class="demo-controls">
                    <ion-button size="small" fill="outline" (click)="setColorOverride(null)"
                        [fill]="colorOverride === null ? 'solid' : 'outline'">Default</ion-button>
                    <ion-button *ngFor="let c of colors" size="small" [color]="c"
                        [fill]="colorOverride === c ? 'solid' : 'outline'"
                        (click)="setColorOverride(c)">{{ c }}</ion-button>
                </div>

                <div class="thumb-row">
                    <!-- 1. Basic -->
                    <div class="thumb-item">
                        <upp-thumb
                            [title]="members[0].name"
                            [detail]="members[0].role"
                            [color]="getColor(members[0])"
                            [icon]="members[0].icon"
                            (Select)="onThumbSelect(members[0].name)">
                        </upp-thumb>
                    </div>

                    <!-- 2. Simple -->
                    <div class="thumb-item">
                        <upp-thumb
                            [title]="members[1].name"
                            [detail]="members[1].role"
                            [color]="getColor(members[1])"
                            [icon]="members[1].icon"
                            (Select)="onThumbSelect(members[1].name)">
                        </upp-thumb>
                    </div>

                    <!-- 3. Round avatar -->
                    <div class="thumb-item">
                        <upp-thumb
                            [title]="members[2].name"
                            [detail]="members[2].role"
                            [color]="getColor(members[2])"
                            [icon]="members[2].icon"
                            [shape]="members[2].shape"
                            (Select)="onThumbSelect(members[2].name)">
                        </upp-thumb>
                    </div>

                    <!-- 4. Card with footer -->
                    <div class="thumb-item">
                        <upp-thumb
                            [title]="members[3].name"
                            [detail]="members[3].role"
                            [foot]="members[3].team"
                            [color]="getColor(members[3])"
                            [icon]="members[3].icon"
                            [card]="members[3].card"
                            (Select)="onThumbSelect(members[3].name)">
                        </upp-thumb>
                    </div>
                </div>
            </div>
        </div>
    </upp-scrollable>
</div>
